import { getApiEndpoint } from "../config/config";

export const attendanceService = {
  // ─── Events ────────────────────────────────────────────────────────────────

  async getAttendanceEvents(jwt) {
    const response = await fetch(getApiEndpoint("/v1/attendance/events"), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    });
    if (!response.ok) throw new Error("Failed to fetch attendance events");
    return await response.json();
  },

  async createAttendanceEvent(data, jwt) {
    const response = await fetch(getApiEndpoint("/v1/attendance/events"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error("Failed to create attendance event");
    return await response.json();
  },

  async updateAttendanceEvent(id, data, jwt) {
    const response = await fetch(
      getApiEndpoint(`/v1/attendance/events/${id}`),
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`,
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) throw new Error("Failed to update attendance event");
    return await response.json();
  },

  async deleteAttendanceEvent(id, jwt) {
    const response = await fetch(
      getApiEndpoint(`/v1/attendance/events/${id}`),
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`,
        },
      }
    );
    if (!response.ok) throw new Error("Failed to delete attendance event");
    return await response.json();
  },

  async getAttendanceEvent(id, jwt) {
    const response = await fetch(
      getApiEndpoint(`/v1/attendance/events/${id}`),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`,
        },
      }
    );
    if (!response.ok) throw new Error("Failed to fetch attendance event");
    return await response.json();
  },

  // ─── QR Code ───────────────────────────────────────────────────────────────

  async getEventQrCode(id, jwt) {
    const response = await fetch(
      getApiEndpoint(`/v1/attendance/events/${id}/qr`),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`,
        },
      }
    );
    if (!response.ok) throw new Error("Failed to fetch QR code");
    return await response.json(); // returns { qrCode: string (data URL) }
  },

  // ─── Attendees ─────────────────────────────────────────────────────────────

  async getEventAttendees(id, jwt) {
    const response = await fetch(
      getApiEndpoint(`/v1/attendance/events/${id}/attendees`),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`,
        },
      }
    );
    if (!response.ok) throw new Error("Failed to fetch attendees");
    return await response.json();
  },

  async manualMarkAttendance(eventId, userId, jwt) {
    const response = await fetch(
      getApiEndpoint(`/v1/attendance/events/${eventId}/mark`),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`,
        },
        body: JSON.stringify({ user_id: userId }),
      }
    );
    if (!response.ok) throw new Error("Failed to mark attendance");
    return await response.json();
  },

  // ─── My Attendance (Rep-facing) ────────────────────────────────────────────

  async getMyAttendance(jwt) {
    const response = await fetch(
      getApiEndpoint("/v1/attendance/my-attendance"),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`,
        },
      }
    );
    if (!response.ok) throw new Error("Failed to fetch my attendance");
    return await response.json();
  },
};
